var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.98 6.459.76.72m1.428 1.354.911.863m1.462 1.385.911.863m1.429 1.353.76.72M12.085 3.69l-9.358 8.865a2.264 2.264 0 0 0 0 3.325l.585.554c.969-.918 2.54-.918 3.509 0a2.264 2.264 0 0 1 0 3.324l.585.554c.969.919 2.54.919 3.51 0l9.357-8.865c.97-.918.97-2.407 0-3.325l-.585-.554c-.969.918-2.54.918-3.509 0a2.264 2.264 0 0 1 0-3.324l-.585-.554c-.969-.919-2.54-.919-3.51 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitation);
export default __webpack_public_path__ + "static/media/invitation.e5c567717e6f2327b5ee7561eb11ffcc.svg";
export { ForwardRef as ReactComponent };